var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-map-overlay',{attrs:{"overlayId":"wgu-hover-tooltip","visible":false,"autoPan":"","autoPanDuration":250,"positioning":"top-center","offset":[0, 20]},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var feature = ref.feature;
var hoverAttribute = ref.hoverAttribute;
return (feature)?_c('v-sheet',{staticClass:"pa-2 text-center",attrs:{"max-width":"200"}},[_vm._v("\n    "+_vm._s(feature.get(hoverAttribute))+"\n  ")]):_vm._e()}}],null,true)})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8c65aae6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ol/HoverTooltip.vue
// module id = +2xm
// module chunks = 1